import { Component, inject, Input } from '@angular/core';
import { Link } from '../../../models/class/link.class';
import { CardsService } from '../../../services/cards/cards.service';
import { TrashComponent } from '../../../../../core/components/svg/trash/trash.component';
import { DatabaseModelService } from '../../../services/database-model/database-model.service';

@Component({
  selector: 'app-link-card',
  standalone: true,
  imports: [TrashComponent],
  templateUrl: './link-card.component.html',
  styleUrls: ['./../card.component.scss'],
})
export class LinkCardComponent {
  @Input()
  link!: Link;

  @Input()
  isEnglish!: boolean;

  databaseModelService: DatabaseModelService = inject(DatabaseModelService);
  cardService: CardsService = inject(CardsService);

  handleHover(hovering: boolean): void {
    if (hovering) this.cardService.setTables(this.link);
    else this.cardService.setTables(undefined);
  }

  deleteLink(): void {
    console.log('delete in link card');
    this.databaseModelService.deleteLink$(this.link);
  }
}
